module.exports = __webpack_public_path__ + "img/LOGO-ADIL-SIMPLE.c3355b69.svg";